import { Injectable, computed, inject, signal } from '@angular/core';
import { PromotionsApiService } from '../api/promotions-api.service';
import { SucursalDescuento, SucursalOferta } from '../models/promociones.model';

@Injectable({ providedIn: 'root' })
export class SucursalesService {
  private api = inject(PromotionsApiService);

  private readonly _sucursales = signal<{ id: string; nombre: string }[]>([]);
  readonly sucursales = this._sucursales.asReadonly();

  readonly cargadas = computed(() => this._sucursales().length > 0);

  constructor() {
    this.cargar();
  }

  cargar(): void {
    this.api.listarSucursales().subscribe({
      next: (lista) =>
        this._sucursales.set(lista.map((s) => ({ id: String(s.id), nombre: s.name }))),
      error: (error) => console.error('[Promociones] No se pudieron cargar las sucursales', error),
    });
  }

  paraDescuento(): SucursalDescuento[] {
    return this._sucursales().map((s) => ({ id: s.id, nombre: s.nombre, incluida: true }));
  }

  paraOferta(): SucursalOferta[] {
    return this._sucursales().map((s) => ({
      id: s.id,
      nombre: s.nombre,
      incluida: false,
      precioPropio: false,
      precio: 0,
    }));
  }
}
